var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-view page-deploy"},[_vm._m(0),_vm._m(1),_c('local-edit-modal',{ref:"local",attrs:{"localId":_vm.localId,"localData":_vm.localData,"type":"deploy"},on:{"localEvent":_vm.localEvent}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('span',{staticClass:"header-text"},[_vm._v("部署巡检点")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deploy-view"},[_c('div',{attrs:{"id":"fengMap"}})])
}]

export { render, staticRenderFns }